import { Box } from "@mui/material"
import { PageCard, PageCardContent } from "components/card"
import React from "react"

export const DiningKioskHPage = ({ Layout = Box }) => {
  return (
    <Layout aside={<></>}>
      <PageCard>
        <PageCardContent>Dining Page</PageCardContent>
      </PageCard>
    </Layout>
  )
}
